import { AppUpdateControl } from 'components/AppUpdateControl';

function Component(props) {
	let { message, policy } = props.routeState;

	return <AppUpdateControl message={message} policy={policy} />;
}

export const AppUpdatePage = Component;
